import { createSlice } from '@reduxjs/toolkit';

const uploadsSlice = createSlice({
  name: 'uploads',
  initialState: {
    byId: {},
    allIds: [],
  },
  reducers: {
    addUpload: (state, action) => {
      const upload = action.payload;
      state.byId[upload.id] = {
        ...upload,
        attachments: upload.attachments || [],
      };
      if (!state.allIds.includes(upload.id)) {
        state.allIds.push(upload.id);
      }
    },
    updateUpload: (state, action) => {
      const { id, ...updates } = action.payload;
      if (state.byId[id]) {
        state.byId[id] = { ...state.byId[id], ...updates };
      }
    },
    updateAttachment: (state, action) => {
      const { uploadId, attachmentId, ...updates } = action.payload;
      if (state.byId[uploadId]) {
        const attachment = state.byId[uploadId].attachments.find(a => a.id === attachmentId);
        if (attachment) {
          Object.assign(attachment, updates);
          // Remove non-serializable File object after upload is complete
          // File objects cause Redux warnings and should be removed once no longer needed
          if (updates.status === 'complete' && attachment.file) {
            delete attachment.file;
          }
        }
      }
    },
    removeUpload: (state, action) => {
      const id = action.payload;
      delete state.byId[id];
      state.allIds = state.allIds.filter(uploadId => uploadId !== id);
    },
  },
});

export const { addUpload, updateUpload, updateAttachment, removeUpload } = uploadsSlice.actions;

export default uploadsSlice.reducer;
